import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EditModeService {
  private editModeSubject: Subject<boolean> = new BehaviorSubject<boolean>(false);
  public editMode$: Observable<boolean> = this.editModeSubject.asObservable();

  public setEditMode(isEditMode: boolean): void {
    this.editModeSubject.next(isEditMode);
  }
}
